export default __webpack_public_path__ + "static/media/My-Zinc-ban.acf0bf73.jpg";